module.exports = "/static/assets/6a8dc5055578021d14e852d671271d5d.png";